/* eslint-disable radix */

interface Operators<T> {
  [key: string]: (a: T, b: T) => boolean;
}

const operators: Operators<string> = {
  ">": (a, b) => parseInt(a) > parseInt(b),
  ">=": (a, b) => parseInt(a) >= parseInt(b),
  "<": (a, b) => parseInt(a) < parseInt(b),
  "<=": (a, b) => parseInt(a) <= parseInt(b),
  "===": (a, b) => a === b,
  "!==": (a, b) => a !== b,
};

export default operators;
